import { useEffect } from 'react'
import { createStore, useStore } from '@w/react-store'

const MOBILE_BREAKPOINT = 768
const MOBILE_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`
const mobileStore = createStore(false)

export function useIsMobile() {
  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_QUERY)
    const update = () => { mobileStore.update(window.innerWidth < MOBILE_BREAKPOINT) }
    mediaQuery.addEventListener('change', update)
    update()
    return () => { mediaQuery.removeEventListener('change', update) }
  }, [])
  return useStore(mobileStore)
}
